import { ToastStatus } from '@/core/components/Toast/Toast';
import useMutation from '@/core/hooks/api/useMutation';
import { APIError } from '@/core/lib/fetch';
import Api from '@/core/lib/new-architecture/api';
import { useToastContext } from '@/core/lib/toast/toast.context';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import { StripeBodySchema } from '@/core/types/stripe';

const useStripeCheckoutSession = () => {
  const toast = useToastContext();
  const { t } = useTranslationContext(['contribute']);

  const stripeCreateCheckoutSessionMutation = useMutation<Awaited<ReturnType<typeof Api.mutation.stripe.createCheckoutSession>>, APIError, StripeBodySchema>({
    mutationFn: async ({ customer_email, priceId, customer_uuid }) => Api.mutation.stripe.createCheckoutSession({ customer_email, priceId, customer_uuid }),
    onError: () => {
      toast?.open(t('errors.create-session-checkout', { ns: 'contribute' }), 2000, ToastStatus.DANGER);
    },
  });
  const onStripeSubmit = async (stripeBody: StripeBodySchema) => stripeCreateCheckoutSessionMutation.mutateAsync(stripeBody);

  return {
    onStripeSubmit,
    isStripeCreateCheckoutSessionPending: stripeCreateCheckoutSessionMutation.isPending,
  };
};

export { useStripeCheckoutSession };
